export enum VkAuthType {
  Button = 'BUTTON',
  Window = 'WINDOW',
}

export type VkAuthSuccessCallback = (props: VkAuthSuccessCallbackProps) => void

export interface VkAuthSuccessCallbackProps {
  code: string
  device_id: string
  state: string
  code_verifier: string
  client_id: string
  redirect_uri: string
}
